import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/viewHK/Home'
import JewelleryHome from '@/views/viewHK/JewelleryHome'
import Product from '@/views/viewHK/Product'
import Login from '@/views/viewHK/Login'
import Register from '@/views/viewHK/Register'
import SelfPage from '@/views/viewHK/MyProfile/SelfPage'
import MyOrder from "@/views/viewHK/MyProfile/MyOrder"
import ShoppingCart from "@/views/viewHK/MyProfile/ShoppingCart"
import OrderDetail from '@/views/viewHK/MyProfile/OrderDetail'
import Order from '@/views/viewHK/Order/Index'
import ConfirmOrder from '@/views/viewHK/Order/ConfirmOrder'
import PayOrder from '@/views/viewHK/Order/PayOrder'
import PaySuccess from '@/views/viewHK/Order/PaySuccess'
import Profile from '@/views/viewHK/Profile'
import Search from '@/views/viewHK/Search'
import GIASearch from '@/views/viewHK/GIASearch'
import AppDownload from "@/views/viewHK/AppDownload";
import BrandStory from "@/views/viewHK/BrandStory";
import GIADetail from "@/views/viewHK/GIADetail";
import Texting from '@/views/viewHK/Texting'
import NotFound from '@/views/404'

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/app-download',
      meta: {'title': '搜飾盒-首頁'}
    },
    {
      path: '/',
      // name: 'Home',
      component: Home,
      children: [
        {
          path: '/jewellery/home',
          name: 'JewelleryHome',
          meta: {'title': '搜飾盒'},
          component: JewelleryHome
        },
        {
          path: '/search/list',
          name: 'Search',
          meta: {'title': '搜飾盒-產品列表'},
          component: Search,
          children: []
        },
        {
          path: '/search/gia',
          name: 'GIASearch',
          meta: {'title': '搜飾盒-GIA'},
          component: GIASearch
        },
        {
          path: '/gia-detail',
          name: 'GIADetail',
          meta: {'title': '搜飾盒-GIA詳情'},
          component: GIADetail
        },
        {
          path: '/search/home/product',
          name: 'Product',
          meta: {'title': '搜飾盒-款式詳情'},
          component: Product
        },
        {
          path: '/',
          // name: 'Order',
          component: Order,
          children: [
            {
              path: '/order/confirm',
              name: 'ConfirmOrder',
              meta: {'title': '搜飾盒-訂單準備'},
              component: ConfirmOrder
            },
            {
              path: '/order/pay',
              name: 'PayOrder',
              meta: {'title': '搜飾盒-訂單支付'},
              component: PayOrder
            },
            {
              path: '/order/success',
              name: 'PaySuccess',
              meta: {'title': '搜飾盒-支付成功'},
              component: PaySuccess
            },
            {
              path: '/order/fail',
              name: 'PayOrder',
              meta: {'title': '搜飾盒-/支付失敗'},
              component: PayOrder
            }
          ]
        },
        {
          path: '/login',
          name: 'Login',
          meta: {'title': '搜飾盒-登錄'},
          component: Login
        },
        {
          path: '/register',
          name: 'Register',
          meta: {'title': '搜飾盒-註冊'},
          component: Register
        },
        {
          path: '/profile',
          // name: 'Profile',
          component: Profile,
          children: [
            {
              path: 'self-page',
              name: 'SelfPage',
              meta: {'title': '搜飾盒-個人信息'},
              component: SelfPage
            },
            {
              path: 'my-order',
              name: 'MyOrder',
              meta: {'title': '搜飾盒-我的訂單'},
              component: MyOrder,

            },
            {
              path: 'shopping-cart',
              name: 'ShoppingCart',
              meta: {'title': '搜飾盒-我的購物車'},
              component: ShoppingCart
            },
            {
              path: 'order-detail',
              name: 'OrderDetail',
              meta: {'title': '搜飾盒-訂單詳情'},
              component: OrderDetail
            },
            {
              path: '/',
              redirect: '/profile/self-page'
            }

          ]
        },
        {
          path: '/app-download',
          name: 'AppDownload',
          component: AppDownload
        },
        {
          path: '/brand-story',
          name: 'BrandStory',
          component: BrandStory
        }
      ]
    },
    {
      path: '/texting',
      name: 'Texting',
      component: Texting
    },
    {
      path: "/404",
      name: "NotFound",
      component: NotFound
    },
    {
      path: "*", // 此處需特別註意置於最底部
      redirect: "/404"
    }

  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let token = localStorage.getItem('Authorization');
  if (token && (to.path === '/login')) {
    next({path: '/'});
  } else {
    next();
  }
});
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js